/**
 * Pilot, ContactPilot's mascot, cut from the owner-supplied pose sheet (2026-11-03).
 * Decorative only: every screen that shows Pilot says the same thing in words.
 */
export type MascotPose =
  | 'thumbs-up' | 'waving' | 'pointing' | 'celebrate' | 'checklist' | 'thinking'
  | 'laptop' | 'idea' | 'success' | 'contact-card' | 'search' | 'inbox';

export function Mascot({ pose, size = 96, className = '' }: { pose: MascotPose; size?: number; className?: string }) {
  return (
    <img
      src={`/mascot/pilot-${pose}.webp`} width={size} height={size} alt="" aria-hidden="true"
      loading="lazy" decoding="async" draggable={false}
      className={`shrink-0 select-none object-contain ${className}`}
      data-mascot={pose}
    />
  );
}
